import * as _ from "lodash";
import * as swal from "sweetalert";

export class ConfigurationManagementPageComponent implements ng.IComponentOptions {
  public controller: any = ConfigurationManagementController;
  public template: string = /*html*/`
    <h2>Configuration Management</h2>
    <form class="form-horizontal" name="$ctrl.configForm" ng-submit="$ctrl.save()">
    <div class="hr-sect">Sites</div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Site Name</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" placeholder="Site Name" ng-model="$ctrl.form.sitename"/>
    </div>
    </div>
    <div class="hr-sect">Email</div>
    <div class="help-block padding-left">Email Content Template shall be written in <a href="https://pugjs.org/">Pug</a>.</div>
    <h4 class="text-center">Registration</h4>
    <div class="form-group">
    <label class="col-sm-2 control-label">Subject</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" placeholder="Subject" ng-model="$ctrl.form.email.register_temp.subject"/>
    </div>
    </div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Content</label>
    <div class="col-sm-10">
      <textarea class="form-control" placeholder="Template" ng-model="$ctrl.form.email.register_temp.content"></textarea>
      <span class="help-block">Parameter: username, password<span>
    </div>
    </div>
    <h4 class="text-center">Approval</h4>
    <div class="form-group">
    <label class="col-sm-2 control-label">Subject</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" placeholder="Subject" ng-model="$ctrl.form.email.approve_temp.subject"/>
    </div>
    </div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Content</label>
    <div class="col-sm-10">
      <textarea class="form-control" placeholder="Template" ng-model="$ctrl.form.email.approve_temp.content"></textarea>
      <span class="help-block">Parameter: username<span>
    </div>
    </div>
    <h4 class="text-center">Rejection</h4>
    <div class="form-group">
    <label class="col-sm-2 control-label">Subject</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" placeholder="Subject" ng-model="$ctrl.form.email.reject_temp.subject"/>
    </div>
    </div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Content</label>
    <div class="col-sm-10">
      <textarea class="form-control" placeholder="Template" ng-model="$ctrl.form.email.reject_temp.content"></textarea>
      <span class="help-block">Parameter: username<span>
    </div>
    </div>
    <h4 class="text-center">Forget Password</h4>
    <div class="form-group">
    <label class="col-sm-2 control-label">Subject</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" placeholder="Subject" ng-model="$ctrl.form.email.forget_pw_temp.subject"/>
    </div>
    </div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Content</label>
    <div class="col-sm-10">
      <textarea class="form-control" placeholder="Template" ng-model="$ctrl.form.email.forget_pw_temp.content"></textarea>
      <span class="help-block">Parameter: username, password<span>
    </div>
    </div>
    <h4 class="text-center">Reminder</h4>
    <div class="form-group">
    <label class="col-sm-2 control-label">Subject</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" placeholder="Subject" ng-model="$ctrl.form.email.reminder_temp.subject"/>
    </div>
    </div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Content</label>
    <div class="col-sm-10">
      <textarea class="form-control" placeholder="Template" ng-model="$ctrl.form.email.reminder_temp.content"></textarea>
      <span class="help-block">Parameter: agency_name, datatype_name, frequency, day, next_due, file_format, worksheet <span>
    </div>
    </div>
    <h4 class="text-center">Organisation User Creation Notification</h4>
    <div class="form-group">
    <label class="col-sm-2 control-label">Subject</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" placeholder="Subject" ng-model="$ctrl.form.email.org_create_temp.subject"/>
    </div>
    </div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Content</label>
    <div class="col-sm-10">
      <textarea class="form-control" placeholder="Template" ng-model="$ctrl.form.email.org_create_temp.content"></textarea>
      <span class="help-block">Parameter: name, email, date, link<span>
    </div>
    </div>
    <h4 class="text-center">Notification</h4>
    <div class="form-group">
    <label class="col-sm-2 control-label">Subject</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" placeholder="Subject" ng-model="$ctrl.form.email.org_dataset_temp.subject"/>
    </div>
    </div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Content</label>
    <div class="col-sm-10">
      <textarea class="form-control" placeholder="Template" ng-model="$ctrl.form.email.org_dataset_temp.content"></textarea>
      <span class="help-block">Parameter: name, email, date, link, organisation<span>
    </div>
    </div>
    <h4 class="text-center">Subscription</h4>
    <div class="form-group">
    <label class="col-sm-2 control-label">Subject</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" placeholder="Subject" ng-model="$ctrl.form.email.subscription_temp.subject"/>
    </div>
    </div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Content</label>
    <div class="col-sm-10">
      <textarea class="form-control" placeholder="Template" ng-model="$ctrl.form.email.subscription_temp.content"></textarea>
      <span class="help-block">Parameter: name, content<span>
    </div>
    </div>
    <div class="hr-sect">Feedback</div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Emails to send</label>
    <div class="col-sm-10">
    <ui-select multiple tagging tagging-label="" ng-model="$ctrl.form.feedback_email">
    <ui-select-match placeholder="Write Email">{{$item}}</ui-select-match>
    <ui-select-choices repeat="email in $ctrl.form.feedback_email | filter:$select.search">
     {{email}}
    </ui-select-choices>
    </ui-select>
    </div>
    </div>
    <div class="hr-sect">Notification</div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Emails to send</label>
    <div class="col-sm-10">
    <ui-select multiple tagging tagging-label="" ng-model="$ctrl.form.notification_email">
    <ui-select-match placeholder="Emails to send notification">{{$item}}</ui-select-match>
    <ui-select-choices repeat="email in $ctrl.form.notification_email | filter:$select.search">
     {{email}}
    </ui-select-choices>
    </ui-select>
    </div>
    </div>
    <div class="hr-sect">Publication</div>
    <div class="form-group">
    <label class="col-sm-2 control-label">Day to publish</label>
    <div class="col-sm-10">
    <input type="number" class="form-control" placeholder="Subject" ng-model="$ctrl.form.publish_day"/>
    </div>
    </div>
    <div class="row">
    <div class="col-md-12 text-center">
      <button class="btn btn-primary" type="submit">Save</button>
      <button class="btn btn-default" type="button" ng-click="$ctrl.sendTestEmail()">Send Test Email</button>
    </div>
    <div class="col-md-12 text-center">
      <button class="btn btn-primary" ng-click="$ctrl.subscription()" type="button">Send Subscription Emails</button>
    </div>
    </div>
    </form>
    `;
}

export class ConfigurationManagementController {
  public static $inject: Array<string> = ["$scope", "$http", "$uibModal"];
  public form: any;
  public configForm: ng.IFormController;
  constructor(private $scope: ng.IScope, private $http: ng.IHttpService, private $uibModal: ng.ui.bootstrap.IModalService) {
    $scope.$emit("adminPageChange",{name:"config"});
    $http.get(`${BASE}/api/configuration`).then((d) => {
      this.form = d.data;
    })
  }
  public save() {
    if (this.configForm.$dirty) {
      this.$http.put(`${BASE}/api/configuration/${this.form._id}`, this.form)
        .then((data) => {
          this.form = data.data;
          this.configForm.$setPristine()
          swal("Sucesss!", "Configuration Updated", "success");
        })
        .catch(() => {
          swal("Sorry!", "Configuration failed to saved. Please try again later", "warning");
        })
    }
  }
  public sendTestEmail() {
    if (this.configForm.$dirty) {
      swal({
        title: "Oops",
        text: "You have unsaved templates, do you want proceed?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        closeOnCancel: true,
        closeOnConfirm: true
      }, (isConfirm) => {
        if (isConfirm) {
          this.openTestEmail();
        }
      });
    }
    else {
      this.openTestEmail();
    }
  }
  public openTestEmail() {
    let modalInstance = this.$uibModal.open({
      component: 'testEmailModal'
    })
    modalInstance.result.then((email) => {
      if (email) {
        swal("Done", `Test Email has been sent to ${email}`, "success");
      }
      else {
        swal("Sorry!", "Test Email failed to send, please try again later", "error");
      }
    })
  }

  public subscription() {
    this.$http.post(`${BASE}/api/subscription`, {})
    .then(() => {
      swal("Email Successfully Sent")
    })
  }
}
